import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Icons } from '../../lib/Icons'
import useRole from '../../hooks/useRole'

export default function QuickActions() {
  const navigate = useNavigate()
  const { isSENCO } = useRole()

  const actions = [
    {
      icon: Icons.AcademicCap,
      title: 'Individual Support Plans',
      desc: 'Full SEN record per pupil: voice, EHCP, interventions, APDR. Downloadable for EHCNA and parent meetings.',
      href: '/isps',
      iconForeground: 'text-indigo-600',
      iconBackground: 'bg-indigo-100',
      hoverBorder: 'hover:border-indigo-300',
      gradient: 'from-indigo-600 to-indigo-400',
    },
    {
      icon: Icons.BookOpen,
      title: 'One-Page Profiles',
      href: '/one-page-profiles',
      iconForeground: 'text-blue-600',
      iconBackground: 'bg-blue-100',
      hoverBorder: 'hover:border-blue-300',
      gradient: 'from-blue-600 to-blue-400',
    },
    {
      icon: Icons.ClipboardDocumentCheck,
      title: 'Interventions',
      desc: 'Log sessions and track intervention progress across groups.',
      href: '/interventions',
      iconForeground: 'text-sky-600',
      iconBackground: 'bg-sky-100',
      hoverBorder: 'hover:border-sky-300',
      gradient: 'from-sky-500 to-cyan-500',
    },
    {
      icon: Icons.Users,
      title: 'Student Directory',
      desc: 'Find and manage all students in your school.',
      href: '/student-organization',
      iconForeground: 'text-teal-600',
      iconBackground: 'bg-teal-100',
      hoverBorder: 'hover:border-teal-300',
      gradient: 'from-teal-500 to-emerald-500',
    },
    {
      icon: Icons.ChartBar,
      title: 'Progress Dashboard',
      desc: 'Track progress and evidence across cohorts.',
      href: '/progress-dashboard',
      iconForeground: 'text-amber-600',
      iconBackground: 'bg-amber-100',
      hoverBorder: 'hover:border-amber-300',
      gradient: 'from-amber-500 to-orange-500',
    },
    ...(isSENCO
      ? [{
          icon: Icons.ChartPie,
          title: 'Cohort Data',
          desc: 'EHCP counts and attainment by year group.',
          href: '/cohort-data',
          iconForeground: 'text-indigo-600',
          iconBackground: 'bg-indigo-100',
          hoverBorder: 'hover:border-indigo-300',
          gradient: 'from-indigo-600 to-violet-500',
        }]
      : []),
  ]

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {actions.map((action) => (
        <button
          key={action.title}
          onClick={() => navigate(action.href)}
          className={`group relative bg-white rounded-2xl p-6 shadow-md hover:shadow-xl border border-gray-100 ${action.hoverBorder} transition-all duration-200 text-left hover:scale-[1.02]`}
        >
          {/* Gradient accent bar */}
          <div className={`absolute top-0 left-0 right-0 h-1 bg-gradient-to-r ${action.gradient} rounded-t-2xl opacity-0 group-hover:opacity-100 transition-opacity`} />
          
          <div className="flex items-start gap-4">
            <div className={`${action.iconBackground} ${action.iconForeground} p-3 rounded-xl shadow-sm group-hover:shadow-md transition-shadow`}>
              <action.icon aria-hidden="true" className="h-6 w-6" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-lg font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
                {action.title}
              </h3>
              <p className="mt-1 text-sm text-gray-500 line-clamp-2">
                {action.desc}
              </p>
            </div>
            <div className="text-gray-300 group-hover:text-blue-400 transition-colors">
              <Icons.ChevronRight className="h-5 w-5" />
            </div>
          </div>
        </button>
      ))}
    </div>
  )
}
